import { useAuthentication } from '@psyomics/ui-common';
import { LoadingSpinner } from '@psyomics/ui-components';
import { useParams, Navigate } from 'react-router-dom';

import { SelfReferral as SelfReferralFeature } from '../../../features/self-referral/self-referral';
import { SelfReferralInit as SelfReferralInitFeature } from '../../../features/self-referral/self-referral-init';

const useSelfReferralCode = () => {
  const { selfReferralCode } = useParams();
  if (!selfReferralCode) throw new Error('no service code');
  return selfReferralCode;
};

const SelfReferralRoute = () => {
  const selfReferralCode = useSelfReferralCode();
  const { isAuthenticated, isLoading } = useAuthentication();

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!isLoading && isAuthenticated) {
    return <Navigate to={`/self-referral/init/${selfReferralCode}`} />;
  }

  return <SelfReferralFeature selfReferralCode={selfReferralCode} />;
};

const SelfReferralInitRoute = () => {
  const selfReferralCode = useSelfReferralCode();
  return <SelfReferralInitFeature selfReferralCode={selfReferralCode} />;
};

export { SelfReferralRoute as SelfReferral, SelfReferralInitRoute as SelfReferralInit };
